import { render, staticRenderFns } from "./cert.vue?vue&type=template&id=0f4ef46a&scoped=true&"
import script from "./cert.vue?vue&type=script&lang=ts&"
export * from "./cert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ef46a",
  null
  
)

export default component.exports